module.exports = __webpack_public_path__ + "img/service-part3-ft.b640e0a7.png";